import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-cycle-report',
  templateUrl: './help-cycle-report.component.html',
  styleUrls: ['./help-cycle-report.component.scss']
})
export class HelpCycleReportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
